import cashflow_1 from "../../../assests/images/cashflow/cashflow_1.png";
import cashflow_2 from "../../../assests/images/cashflow/cashflow_2.png";
import cashflow_3 from "../../../assests/images/cashflow/cashflow_3.png";

export const cardData = [
  {
    id: 1,
    label: "Quick and simple",
    description:
      "The Accountant pact is a unique supplier of technology-driven products and services designed to make the accounting journey quicker and easier for everyone involved. We have been serving the Accounting market for over a decade and have gained an invaluable understanding of the opportunities and challenges faced by the industry.",
    image: cashflow_1,
    bgColor: "rgba(255, 248, 248, 1)",
    img_padding: "30px"
  },
  {
    id: 2,
    label: "Automation",
    description:
      "The Accountant pact is a unique supplier of technology-driven products and services designed to make the accounting journey quicker and easier for everyone involved.",
    image: cashflow_2,
    bgColor: "#F8FFF5",
    scaleX: "scaleX(-1)",
    padding: "130px",
    ul: ["Speed up your move", "Quick and easy to buy"],
  },
  {
    id: 3,
    label: "Quick and simple ",
    description:
      "The Accountant pact is a unique supplier of technology-driven products and services designed to make the accounting journey quicker and easier for everyone involved.",
    image: cashflow_3,
    bgColor: "rgba(255, 248, 248, 1)",
    ul: [
      "Rent arrears covered for up to 12 months",
      "Covers evicyion for any breach of tenancy",
      "No excess",
    ],
  },
];


export const receivableData = [

    {
        id: 1,
        text: `Accountant Pact contains everything you need for faster Accounting journey of your company`,
        bgColor: "#3AA1FF",
        justifyContent:'start',
        width:'300px',
        margin:'40px 0 25px 0',
    },
    {
        id: 2,
        text: `Accountant Pact contains everything you need for faster Accounting journey of your company.`,
        bgColor: "#DBDD3B",
        justifyContent:'end',
        width:'450px',
        margin:'25px'
    },
    {
        id: 3,
        text: `Accountant Pact contains everything you need for faster Accounting journey of your company`,
        bgColor: "#FF8AA6",
        justifyContent:'start',
        width:'450px',
        margin:'25px 0 25px -25px'
    },
    {
        id: 4,
        text: `Accountant Pact contains everything you need for faster Accounting journey of your company`,
        bgColor: "#58BACA",
        justifyContent:'end',
        width:'350px',
        margin:'25px'
    },
]